import { createReducer } from 'redux-act';
import {requestAudienceOverview, responseAudienceOverview} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestAudienceOverview]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responseAudienceOverview]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
